import { useTranslation } from 'react-i18next';
import { FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';
import { Paragraph, Link } from './ui';

function Footer() {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-neutral-100 dark:bg-neutral-900 text-neutral-700 dark:text-neutral-200 py-8">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <Paragraph>{t('copyright')}</Paragraph>
          <div className="flex gap-6">
            <Link href="https://facebook.com" external className="hover:text-primary-500 transition-colors">
              <FaFacebook className="w-6 h-6" />
            </Link>
            <Link href="https://instagram.com" external className="hover:text-primary-500 transition-colors">
              <FaInstagram className="w-6 h-6" />
            </Link>
            <Link href="https://twitter.com" external className="hover:text-primary-500 transition-colors">
              <FaTwitter className="w-6 h-6" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;